export const CONTENT_HIGHLIGHT_CLASS = "bg-amber-50";
